import React from 'react'
import PropTypes from 'prop-types'
import useDepartmentId from 'support/hooks/use-department-id'
import { useFieldName } from '@morningtrain/react-fields'

function SelectedDepartmentField ({ name }) {
  const [departmentId] = useDepartmentId()

  const fieldName = useFieldName(name)

  return (
    <input
      name={fieldName}
      type='hidden'
      value={departmentId}
    />
  )
}

SelectedDepartmentField.defaultProps = {
  name: 'department_id'
}

SelectedDepartmentField.propTypes = {
  name: PropTypes.string
}

export default SelectedDepartmentField
